import { DateWithTimezones } from '../../common';

export interface ShipmentTransitTime {
  arrivalDeviation: string;
  departureDeviation: string;
  arrival: DateWithTimezones;
  departure: DateWithTimezones;
  total: string;
  totalDeviation: string;
}

export interface ShipmentTransportOrderTransitTime {
  arrivalDeviation: string;
  departureDeviation: string;
  arrival: DateWithTimezones;
  departure: DateWithTimezones;
  total: string;
  totalDeviation: string;
}
